import { MutableRefObject, useEffect } from 'react';

import { getEventPath } from 'lib/utils/dom';

/*
 * When a focus change or click happens on the page, check if containerEl
 * is in the event path. If not, it means the current "active" tree has changed
 * and we invoke the callback.
 */
const useContainerTargetDetector = (
  cb: (evt: Event) => void,
  ...containerEls: Array<MutableRefObject<any>>
) =>
  useEffect(() => {
    const handleEvent = (evt: Event) => {
      const path = getEventPath(evt);
      if (!containerEls.some((el) => path.includes(el.current))) {
        cb(evt);
      }
    };

    window.addEventListener('focusin', handleEvent);
    window.addEventListener('click', handleEvent);

    return () => {
      window.removeEventListener('focusin', handleEvent);
      window.removeEventListener('click', handleEvent);
    };
  }, [cb, ...containerEls]);

export default useContainerTargetDetector;
